module.exports = __webpack_public_path__ + "static/media/building_6.ef9c5fd1.jpg";